function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.ut0{fill:none;stroke:#5d6477;stroke-width:2;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "Path_13",
  className: "ut0",
  d: "M23.4,15v-1.6c0-0.2,0.1-0.4,0.2-0.6l2.2-1.8c0.2-0.2,0.3-0.5,0.2-0.7l-0.6-1.6 C25.4,8.2,25,8,24.7,8L22,8.2c-0.2,0-0.5-0.1-0.6-0.2l-1.1-1.1c-0.1,0-0.2-0.4-0.2-0.6l0.2-2.7c0.1-0.4-0.2-0.8-0.6-1L18.2,2h-0.4 c-0.2,0-0.6,0-0.7,0.4l-2,2.3h-2.2l-1.8-2.3C10.9,2.1,10.6,2,10.3,2H10L8.6,2.5C8.2,2.5,8,3.1,8,3.5l0.2,2.7c0,0.2,0,0.5-0.2,0.6 C7.6,7.1,7.1,7.5,6.8,7.9C6.6,8,6.4,8.1,6.2,8.1L3.5,7.9c-0.4,0-0.7,0.2-0.9,0.6L2,9.8c-0.1,0.4,0,0.8,0.2,1.1l2,1.7 c0.1,0.2,0.2,0.4,0.2,0.6v1.6c0,0.2,0,0.5-0.2,0.6l-2,1.6c-0.4,0.2-0.5,0.7-0.2,1.1l0.5,1.3c0.1,0.4,0.5,0.6,0.9,0.6l2.4-0.2 c0.2,0,0.5,0,0.6,0.2c0.3,0.5,0.8,0.9,1.2,1.2c0.1,0.2,0.2,0.4,0.2,0.6l-0.2,2.4c0,0.4,0,0.9,0.6,1L9.6,26H10 c0.3,0,0.6-0.1,0.7-0.4l1.6-2c0.1,0,0.4-0.2,0.5-0.2h2.1l1.8,2.2c0.2,0.2,0.4,0.4,0.7,0.4h0.4l1.3-0.5c0.4,0,0.6-0.6,0.6-1L19.5,22 c0-0.2,0.1-0.4,0.2-0.6c0.5-0.3,0.9-0.8,1.2-1.2c0.1,0,0.4-0.2,0.6-0.2l2.6,0.2c0.4,0,0.7-0.2,0.9-0.6l0.6-1.3 c0.2-0.4,0.2-0.9-0.1-1.2l-2-1.6C23.6,15.3,23.4,15.3,23.4,15z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "ut0",
  cx: 14,
  cy: 14,
  r: 4.5
}));

var SvgSettings = function SvgSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings.c32cf02d.svg";
export { ForwardRef as ReactComponent };